import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html'
})
export class ConfigurationComponent implements OnInit {
  mostrarDestinoOriginal = false;

  constructor(
    public dialogRef: MatDialogRef<ConfigurationComponent>
  ) {}

  ngOnInit() {
    this.mostrarDestinoOriginal = localStorage.getItem('mostrar_destino_original') === 'true';
  }

  onToggle() {
    localStorage.setItem('mostrar_destino_original', JSON.stringify(this.mostrarDestinoOriginal));
    window.dispatchEvent(new Event('mostrar_destino_original_changed'));
  }

  close() {
    this.dialogRef.close();
  }
}
